import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const PLAN_LABELS = { free: 'Free', pro: 'Pro', enterprise: 'Enterprise' };

const AdminCompaniesTab = ({ users }) => {
  const { t } = useLanguage();
  const [search, setSearch] = useState('');

  const companies = (users || []).filter(u => u.team_name);
  const filtered = companies.filter(c => {
    const q = search.toLowerCase();
    return (
      c.team_name.toLowerCase().includes(q) ||
      (c.industry || '').toLowerCase().includes(q) ||
      (c.name || '').toLowerCase().includes(q) ||
      (c.email || '').toLowerCase().includes(q)
    );
  });

  return (
    <div className="bg-white card-shadow-lg rounded-xl p-8">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-4">
        <h3 className="text-lg font-semibold text-black">{t('adminCompanies.title', `Empresas Registradas (${companies.length})`).replace('{n}', companies.length)}</h3>
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={t('adminCompanies.searchPlaceholder', 'Buscar por empresa, rubro o usuario...')}
          className="text-sm border border-gray-300 rounded-lg px-3 py-2 w-72"
        />
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {t('adminCompanies.company', 'Empresa')}
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {t('adminCompanies.industry', 'Rubro')}
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {t('adminCompanies.description', 'Descripción')}
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {t('adminCompanies.user', 'Usuario')}
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Plan
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filtered.map((c) => (
              <tr key={c.id}>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-gray-900">{c.team_name}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {c.industry ? (
                    <span className="inline-flex px-2 py-0.5 text-xs font-medium rounded-full bg-purple-100 text-purple-800">
                      {c.industry}
                    </span>
                  ) : (
                    <span className="text-sm text-gray-400">—</span>
                  )}
                </td>
                <td className="px-6 py-4 max-w-xs">
                  <div className="text-sm text-gray-600 truncate" title={c.company_description || ''}>
                    {c.company_description || <span className="text-gray-400">{t('adminCompanies.noDescription', 'Sin descripción')}</span>}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-gray-900">{c.name}</div>
                  <div className="text-sm text-gray-500">{c.email}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="inline-flex px-2 py-0.5 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                    {PLAN_LABELS[c.plan] || c.plan || 'Free'}
                  </span>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan="5" className="px-6 py-8 text-center text-sm text-gray-400">
                  {t('adminCompanies.empty', 'No hay empresas registradas todavía.')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default AdminCompaniesTab;
